import React, { Component } from "react";
import { connect } from "react-redux";
import OfflinePage from "../../OfflinePage/OfflinePage";
import {
  OrderWrapper,
  PickerOuterWrapper,
} from "../../PickerOrder/PickerOrder.style";
import { Button, Divider, Input, message } from "antd";
import UserGreeting from "../../../components/UserGreeting/UserGreeting";
import TitleWrapper from "../../../components/TitleWrap/TitleWrap";
import { TOPickerWrapper } from "./TOPickerOrder.styled";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { withRouter } from "react-router-dom";
import { getTOPickerOrderThunk } from "../../../redux/TOThunks/Action";
import TMLoader from "../../../components/Loader/Loader";

export class TOPickerOrder extends Component {
  state = {
    transferOrderId: "",
    serviceLoading: false,
  };

  redirectToDetailsPage = (toNumber) => {
    this.props.history.push(
      `/to-picker-order-process/${Base64func(toNumber, "encode")}`
    );
  };

  getTOPickerDetails = (toNumber) => {
    // get orders from order id function here

    this.setState(
      {
        serviceLoading: true,
      },
      () => {
        let data = {
          transferOrderId: this.state.transferOrderId,
          access_token: this.props.access_token,
          history: this.props.history,
        };
        if (toNumber) {
          data.toNumber = toNumber;
        }

        this.props.getTOPickerOrderThunk(data).then(() => {
          this.setState({
            serviceLoading: false,
          });
          if (this.props.TOReducer?.TOOrderErr) {
            message.error(this.props.TOReducer?.TOOrderErr);
          } else if (this.props.TOReducer?.TOOrderData?.transferOrderNumber) {
            this.props.history.push(
              `/to-picker-order-process/${Base64func(
                this.props.TOReducer?.TOOrderData?.transferOrderNumber,
                "encode"
              )}`
            );
          } else if (
            this.props.TOReducer?.TOOrderData &&
            !this.props.TOReducer?.TOOrderData?.transferOrderNumber
          ) {
            message.error(this.props.TOReducer?.TOOrderData);
          }
        });
      }
    );
  };

  render() {
    let { isOnline } = this.props;
    let { transferOrderId, serviceLoading } = this.state;
    return (
      <PickerOuterWrapper className="centerScreen">
        {serviceLoading ? <TMLoader /> : null}

        {isOnline ? (
          <TOPickerWrapper>
            <UserGreeting />
            <div>
              <TitleWrapper title={"Transfer Order Picker"} />
              <OrderWrapper>
                <div className="inputWrap">
                  <Input
                    type="number"
                    placeholder={"Enter TO ID"}
                    onChange={(e) => {
                      this.setState({
                        transferOrderId: e.target.value,
                      });
                    }}
                    autoFocus
                    value={transferOrderId}
                    onPressEnter={() => {
                      this.redirectToDetailsPage(transferOrderId);
                    }}
                    min={0}
                  />
                </div>
                <div className="btnWrap">
                  <Button
                    onClick={() => {
                      this.redirectToDetailsPage(transferOrderId);
                    }}
                    disabled={
                      !this.state.transferOrderId ||
                      this.state.transferOrderId?.trim()?.length === 0
                    }
                  >
                    {"Search"}
                  </Button>
                </div>
              </OrderWrapper>
            </div>

            <Divider>Or</Divider>

            <button className="bbtn" onClick={() => this.getTOPickerDetails()}>
              Get Transfer Order
            </button>
          </TOPickerWrapper>
        ) : (
          <OfflinePage />
        )}
      </PickerOuterWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

const mapDispatchToProps = {
  getTOPickerOrderThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TOPickerOrder)
);
